// Shared empty-state, "sign in to view", and "not found" copy.
//
// Used across both producer and actor surfaces of the SPA. The strings here
// are deliberately neutral: short, no warning red (per friendly_ui_tone.md),
// first-person where the user is the addressee. Spanish uses formal "usted".
//
// Add new entries when you find duplicate or near-duplicate UI strings —
// keep this module the single home for shared microcopy so we don't fork
// translations across routes.
/** "Resource not found" empty states. Tone: brief, not alarming. */
export const NOT_FOUND = {
    project: {
        en: 'Project not found.',
        es: 'Proyecto no encontrado.',
        zh: '找不到该项目。',
    },
    load_project: {
        en: 'Could not load project.',
        es: 'No se pudo cargar el proyecto.',
        zh: '无法加载项目。',
    },
};
/** "Sign in to view" gate states for actor account pages. */
export const SIGN_IN_REQUIRED = {
    payment: {
        en: 'You must be signed in to view payment settings.',
        es: 'Debe iniciar sesión para ver la configuración de pagos.',
        zh: '请先登录以查看付款设置。',
    },
    earnings: {
        en: 'You must be signed in to view earnings.',
        es: 'Debe iniciar sesión para ver sus ganancias.',
        zh: '请先登录以查看收入。',
    },
    devices: {
        en: 'You must be signed in to test devices.',
        es: 'Debe iniciar sesión para probar dispositivos.',
        zh: '请先登录以测试设备。',
    },
    profile: {
        en: 'You must be signed in to view your account.',
        es: 'Debe iniciar sesión para ver su cuenta.',
        zh: '请先登录以查看账户。',
    },
    data_export: {
        en: 'You must be signed in to request a data export.',
        es: 'Debe iniciar sesión para solicitar una exportación de datos.',
        zh: '请先登录以申请导出数据。',
    },
    security: {
        en: 'Sign in to view security.',
        es: 'Inicie sesión para ver la seguridad.',
        zh: '请先登录以查看安全设置。',
    },
};
/** Empty-list / no-data filler for tables, scene blocks, take strips, etc. */
export const EMPTY = {
    no_line_text: {
        en: 'No line text on this cue.',
        es: 'Sin texto de diálogo en esta toma.',
        zh: '该 cue 暂无台词。',
    },
    no_cues_in_scene: {
        en: 'No cues in this scene.',
        es: 'Sin cues en esta escena.',
        zh: '本场没有 cue。',
    },
    no_cues_yet: {
        en: 'No cues yet.',
        es: 'Aún no hay cues.',
        zh: '暂无 cue。',
    },
    no_batches_assigned: {
        en: 'No batches assigned yet.',
        es: 'Aún no se le ha asignado ningún lote.',
        zh: '暂未分配批次。',
    },
    no_annual_data: {
        en: 'No annual data yet.',
        es: 'Aún no hay datos anuales.',
        zh: '暂无年度数据。',
    },
    no_batches_yet: {
        en: 'No batches yet.',
        es: 'Aún no hay lotes.',
        zh: '暂无批次。',
    },
    no_reference_for_cue: {
        en: 'No reference for this cue.',
        es: 'No hay referencia para esta toma.',
        zh: '该 cue 暂无参考音频。',
    },
    not_yet_run: {
        en: 'Not yet run',
        es: 'Aún sin ejecutar',
        zh: '未运行',
    },
};
/** Common dropdown placeholders. */
export const PLACEHOLDERS = {
    pick_character: {
        en: 'Pick a character...',
        es: 'Elija un personaje...',
        zh: '选择角色…',
    },
    invite_new_actor: {
        en: 'Invite new actor...',
        es: 'Invitar a nuevo actor...',
        zh: '邀请新演员…',
    },
};
/** Mobile / device-context guards. */
export const DEVICE_GATE = {
    desktop_required_title: {
        en: 'Open this on a desktop',
        es: 'Abra esto en un escritorio',
        zh: '请在电脑上打开',
    },
};
/** Account / actor-only gating message. */
export const ACCESS = {
    actor_only_section: {
        en: 'This section is only available to actor accounts.',
        es: 'Esta sección está disponible solo para cuentas de actor.',
        zh: '此部分仅供演员账户使用。',
    },
};
